import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const CustomButtonWhite = styled(Button)({
  backgroundColor: "white",
  width: "100%",
  height: "60px",
  color: "#00205b",
  textDecoration: "none",
  borderRadius: "30px",
  "&:hover": {
    backgroundColor: "#6edcfa",
    boxShadow: "none",
  },
});
